/* eslint-disable  sort-keys */

// Import SVGs as React components
import { ReactComponent as EmotionsIcon } from "../../../assets/icons/Emotions_Icon.svg";
import { ReactComponent as EmpathyCompassionIcon } from "../../../assets/icons/EmpathyCompassion_Icon.svg";
import { ReactComponent as HomeIcon } from "../../../assets/icons/Home_Icon.svg";
import { ReactComponent as RelationshipStrategiesIcon } from "../../../assets/icons/RS_Icon.svg";
import { ReactComponent as SelfOtherIcon } from "../../../assets/icons/SelfOther_Icon.svg";

export const reportNavLinks = {
	introduction: {
		icon: <HomeIcon />,
		label: "Introduction"
	},
	summary: {
		icon: <HomeIcon />,
		label: "Report Summary"
	},
	emotions: {
		icon: <EmotionsIcon />,
		label: "Emotions"
	},
	"self-other": {
		icon: <SelfOtherIcon />,
		label: "Self-Other"
	},
	"empathy-compassion": {
		icon: <EmpathyCompassionIcon />,
		label: "Empathy Compassion"
	},
	"relationship-strategies": {
		icon: <RelationshipStrategiesIcon />,
		label: "Relationship Strategies"
	}
};

/**
 * Emotion to field mapping
 */
export const emotionToFields = {
	Anger: "fANG",
	Anxiety: "fANX",
	Fear: "fEA",
	Joy: "fJO",
	Love: "fLO",
	Sadness: "fSA",
	Shame: "fSHA"
};

export const relationshipStrategyToField = {
	dependent: "lSHO",
	disconnected: "lSLO",
	independent: "hSLO",
	interdependent: "hSO",
};

export const relationshipStrategyColor = {
	interdependent: "bg-eqqo-green",
	independent: "bg-eqqo-blue",
	dependent: "bg-eqqo-yellow",
	disconnected: "bg-eqqo-red"
}